import Icon from 'veui/components/Icon'
import { IconHospital } from 'dls-icons-vue'

Icon.register('hospital', IconHospital)
